import { render } from "./AttachmentSvgIcon.vue?vue&type=template&id=558f0a48"
import script from "./AttachmentSvgIcon.vue?vue&type=script&lang=js"
export * from "./AttachmentSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__